export default "__VITE_ASSET__BS2X7RqB__"